import Avatar from "./Avatar";
import Username from "./Username";

import "./Index.scss";

const Profile = () => (
  <div className="preferencesProfile">
    <Avatar />
    <Username />
  </div>
);

export default Profile;
